import React, { useState, useRef, useEffect } from "react";
import "./BatchViewModal.scss";
import BaseDrawer from "../UI/BaseDrawer/BaseDrawer";
import CustomForm from "../UI/CustomForm/CustomForm";
import BaseCard from "../UI/BaseCard/BaseCard";
import { editBatch } from "../../util/API/batch";
import PinPad from "../PinPad/PinPad";
import CustomAlert from "../UI/CustomAlert/CustomAlert";

function BatchViewModal({ open, closeModal, selectedBatch, getHistoryList }) {
  console.log("selectedBatch-------------", selectedBatch);
  const [showPinPad, setShowPinPad] = useState(false);
  const [submittedFormData, setSubmittedFormData] = useState(null);
  const [alert, setAlert] = useState(
    {
      showAlert: false,
      severity: "error",
      header: "",
      message: ""
    }
  );

  const handleConfirm = (event, pin) => {
    let PIN = pin.join('');
    handleSubmit(event, PIN);
    setShowPinPad(false);
  };

const handlePinPad = (data, formData) => {
  console.log("Captured form data:", data, formData);
  setSubmittedFormData({
    data,
    formData,
  });
  setShowPinPad(true);
};

// const formatScheduleTime = (isoString) => {
//   const date = new Date(isoString);
//   const year = date.getFullYear();
//   const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are 0-based
//   const day = String(date.getDate()).padStart(2, "0");
//   const hours = String(date.getHours()).padStart(2, "0");
//   const minutes = String(date.getMinutes()).padStart(2, "0");
//   const seconds = String(date.getSeconds()).padStart(2, "0");

//   return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
// };

  const handleSubmit = async(e, PIN) => {
    if (!submittedFormData) {
      console.error("No form data found to submit with PIN.");
      return;
    }
  
    const { data } = submittedFormData;
  
    const payload = {
      ...data,
      PIN,
    };
    console.log("data", payload);

    try {
      const response = await editBatch(
        payload?.requestuserid,
        payload?.requestid,
        PIN,
        payload?.scheduletime,
        payload?.notes
      );
      console.log(response);
      if (response?.callStatus === "1") {
        setAlert({
          ...alert,
          showAlert: true,
          severity: "success",
          header: "Success",
          message: "Batch Entry Updated Successfully",
        });
        getHistoryList();
      } else {
        console.log(response);
        setAlert({
          showAlert: true,
          severity: "error",
          message: "Batch Upload was not updated successfully",
          header: "Error!",
        });
      }
    } catch (error) {
      console.log(error);
    }
  }

  return (
    <BaseDrawer
      open={open}
      handleClose={closeModal}
      height="90vh"
      title={"Edit Batch Entry"}
    >

      <BaseCard>
        <CustomForm
          formName={"editBatchEntry"}
          buttonText={"Submit"}
          onSubmit={handlePinPad}
          loadingButtonText={"Loading ..."}
          formValues={selectedBatch}
        />
      </BaseCard>
      {showPinPad && <PinPad show={showPinPad} handleConfirm={handleConfirm} onClick={() => setShowPinPad(false)} />}
      <CustomAlert severity={alert.severity} show={alert.showAlert} header={alert.header} message={alert.message} onClick={(prev) => {setAlert({...prev, showAlert: false}); closeModal()}} autoclose={alert.severity === "error" ? false : true} />
    </BaseDrawer>
  );
}

export default BatchViewModal;
